let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';
import { useTheme } from 'foundations-theming/utils';
import { isKnownThinFontFamily, MODIFIED_BODY_FONT_WEIGHT } from '../utils/registry';

// Some nested foundations-components (e.g. the date picker's day cells and
// weekday headers) style text with raw styled-components that omit `fontFamily`,
// so they don't pick up the brand font and fall back to the default. Set the
// brand body font as the document base font so that inherited text uses it.
import { jsx as _jsx } from "react/jsx-runtime";
const StyledGlobalFontOverrides = createGlobalStyle(_t || (_t = _`
  body {
    font-family: ${0} !important;
    ${0}
  }
`), ({
  $bodyFontFamily
}) => $bodyFontFamily, ({
  $bodyFontWeight
}) => $bodyFontWeight ? `font-weight: ${$bodyFontWeight} !important;` : '');
export const GlobalFontStyles = () => {
  var _theme$typography$bod;
  const theme = useTheme();
  // All body tokens are set to the same font family, so body-200 is just a
  // representative choice here — nothing special about it.
  const bodyFontFamily = (_theme$typography$bod = theme.typography['body-200']) === null || _theme$typography$bod === void 0 ? void 0 : _theme$typography$bod.fontFamily;
  if (!bodyFontFamily) return null;

  // Keyed off the resolved token family rather than brand settings: theme
  // settings can override the brand body font, and the floor must follow the
  // font that actually renders.
  const bodyFontWeight = isKnownThinFontFamily(bodyFontFamily) ? String(MODIFIED_BODY_FONT_WEIGHT) : undefined;
  return /*#__PURE__*/_jsx(StyledGlobalFontOverrides, {
    $bodyFontFamily: bodyFontFamily,
    $bodyFontWeight: bodyFontWeight
  });
};